import {loadAssetRegistry,onAssetRegistryChanged} from './assetRepository';
import {seedSoundAssets} from './audioDefaults';

interface BrowserAudioManager {
  setRegistry:(registry:unknown)=>number;
  emit:(eventKey:string,options?:Record<string,unknown>)=>boolean;
  saveSettings:(settings:Record<string,unknown>)=>Record<string,unknown>;
}

declare global {
  interface Window { MatterMazeAudio?:{manager:BrowserAudioManager} }
}

export function initializeAudioRuntime(){
  window.MatterMazeAudio?.manager.setRegistry({schema:9,paletteId:'RW_MASTER_256_V1',assets:seedSoundAssets()});
  const sync=()=>void loadAssetRegistry().then(registry=>{if(registry)window.MatterMazeAudio?.manager.setRegistry({...registry,assets:registry.assets.filter(asset=>asset.category==='sound')})}).catch(error=>console.warn('Audio registry load failed.',error));
  return onAssetRegistryChanged(sync);
}

export function emitUiAudio(eventKey:string,options:Record<string,unknown>={}){
  try{return window.MatterMazeAudio?.manager.emit(eventKey,options)??false}catch{return false}
}
